import React from 'react';
import Input from '../../../../common/input';
import CurrencyInput from '../../../../common/currencyInput';
import CancelButtonLink from '../../../../common/buttons/cancelButtonLink';
import Checkbox from '../../../../common/simpleCheckbox';
import DatePickerRedux from '../../../../common/DatePickerRedux';
import * as shapes from '../shapes';
import { stripWhitespace } from '../../../../common/formFields/normalizers';
import Select from '../../../../common/select';
import { PROMO_TYPE } from '../constants';
import PromoSchedule from './PromoSchedule';
import PromoUsableEveryNumberOfDays from './PromoUsableEveryNumberOfDays';
import PromoUsableNumberOfTimes from './PromoUsableNumberOfTimes';
import PromoForServicesAndProducts from './PromoForServicesAndProducts';
import AssignedShops from './AssignedShops';
import { USER_TYPES } from '../../../../auth/constants';
import { RoleAllowBrand, RoleDenyBrand } from '../../../../auth/roleAware';
import Pill from '../../../../common/Pill';
import BrandPromoModal from './BrandPromoModal';

const Form = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  edit,
  onDelete,
  baseUrl,
  isPercentage,
  onKindChange,
  isScheduled,
  isUsableEveryNumberOfDays,
  isUsableNumberOfTimes,
  isForServicesOrProducts,
  services,
  products,
  shops,
  change,
  isEditingDisabled,
  isBrandPromo,
  brandErrorOff,
  brandErrorIsOn,
  usableEveryNumberOfDays,
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <div className="o-flexbox o-flexbox--content-align-center o-flexbox--justify-start u-mb">
          <h2 className="c-heading c-heading--lightgrey">
            Promo Code
          </h2>
          <Pill
            type="info"
            className="u-ml-"
            display-if={isBrandPromo}
          >
            brand
          </Pill>
        </div>
        <form onSubmit={handleSubmit}>
          <fieldset disabled={submitting || isEditingDisabled}>
            <div className="u-ph">
              <div className="layout">
                <div className="layout__item u-1/2-large-and-up">
                  <span className="c-label-new">Name</span>
                  <Input
                    className="c-input"
                    name="code"
                    type="text"
                    placeholder="Promo name"
                    normalize={stripWhitespace}
                  />
                </div>
                <div className="layout__item u-1/2-large-and-up">
                  <span className="c-label-new">Type</span>
                  <Select
                    name="kind"
                    className="c-select u-mt0"
                    onChange={onKindChange}
                    parse={value => parseInt(value, 10)}
                    options={[{
                      label: 'Fixed amount',
                      value: PROMO_TYPE.amount,
                    }, {
                      label: 'Percentage',
                      value: PROMO_TYPE.percentage,
                    }]}
                  />
                </div>
                <div className="layout__item u-1/2-large-and-up">
                  <span className="c-label-new">Value</span>
                  <CurrencyInput
                    className="c-input"
                    name="value"
                    display-if={!isPercentage}
                  />
                  <Input
                    className="c-input c-input--prepend"
                    name="value"
                    type="number"
                    placeholder="Value"
                    prefix="%"
                    display-if={isPercentage}
                  />
                </div>
                <div className="layout__item">
                  <div className="layout layout--small layout--auto">
                    <div className="layout__item">
                      <Checkbox
                        id="firstAppointmentOnly"
                        name="firstAppointmentOnly"
                        label="First appointment only"
                      />
                    </div>
                  </div>
                </div>
                <div className="layout__item">
                  <div className="layout layout--small layout--auto">
                    <div className="layout__item">
                      <Checkbox
                        id="oneTime"
                        name="oneTime"
                        label="One time promo"
                      />
                    </div>
                  </div>
                </div>
                <div className="layout__item">
                  <span className="c-label-new">Expiration Date</span>
                  <DatePickerRedux
                    className="c-input"
                    name="expirationDate"
                    addClearBtn
                    startDate={new Date()}
                    defaultValue={''}
                    readOnly
                  />
                </div>
                <div className="layout__item u-nowrap">
                  <PromoSchedule isScheduled={isScheduled} />
                </div>
                <div className="layout__item">
                  <PromoUsableEveryNumberOfDays
                    isUsableEveryNumberOfDays={isUsableEveryNumberOfDays}
                    usableEveryNumberOfDays={usableEveryNumberOfDays}
                  />
                </div>
                <div className="layout__item">
                  <PromoUsableNumberOfTimes isUsableNumberOfTimes={isUsableNumberOfTimes} />
                </div>
                <RoleDenyBrand>
                  <div className="layout__item">
                    <PromoForServicesAndProducts
                      isForServicesOrProducts={isForServicesOrProducts}
                      services={services}
                      products={products}
                    />
                  </div>
                </RoleDenyBrand>
                <RoleAllowBrand deny={USER_TYPES.brand}>
                  <div className="layout__item">
                    <span className="c-label-new">Assigned shops</span>
                    <AssignedShops shops={shops} change={change} />
                  </div>
                </RoleAllowBrand>
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right">
              <button
                type="button"
                className="c-btn c-btn--red u-width-120 u-mr- u-float-left"
                onClick={onDelete}
                disabled={isEditingDisabled}
                display-if={edit}
              >
                <span className="c-btn__text">Delete</span>
              </button>
              <CancelButtonLink link={baseUrl} content="Cancel" />
              <button
                type="submit"
                className="c-btn u-width-120"
                disabled={pristine || !valid || isEditingDisabled}
              >
                <span className="c-btn__text">Save</span>
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
    <BrandPromoModal close={brandErrorOff} display-if={brandErrorIsOn} />
  </div>
);
Form.propTypes = {
  handleSubmit: shapes.handler,
  onDelete: shapes.handler,
  edit: shapes.edit,
  pristine: shapes.pristine,
  submitting: shapes.submitting,
  valid: shapes.valid,
  baseUrl: shapes.url,
  isPercentage: shapes.flag,
  onKindChange: shapes.handler,
  isScheduled: shapes.flag,
  isUsableEveryNumberOfDays: shapes.flag,
  isUsableNumberOfTimes: shapes.flag,
  isForServicesOrProducts: shapes.flag,
  services: shapes.array,
  change: shapes.handler.isRequired,
  shops: shapes.shops.isRequired,
  isEditingDisabled: shapes.flag.isRequired,
  isBrandPromo: shapes.flag.isRequired,
  brandErrorOff: shapes.handler.isRequired,
  brandErrorIsOn: shapes.flag.isRequired,
  usableEveryNumberOfDays: shapes.number,
};
Form.defaultProps = {
  handleSubmit: () => null,
  onDelete: () => null,
  onKindChange: () => null,
  edit: false,
  pristine: false,
  submitting: false,
  valid: false,
  baseUrl: '/settings/taxes',
  isPercentage: false,
  isScheduled: false,
  isUsableEveryNumberOfDays: false,
  isUsableNumberOfTimes: false,
  isForServicesOrProducts: false,
  services: [],
  usableEveryNumberOfDays: null,
};

export default Form;
